'use strict'

import user from './userModel'
import sample from './sampleModel'
import current from './currentModel'
import group from './groupModel'
import device from './deviceModel'
import tab from './tabModel'

export default {
  user,
  sample,
  current,
  group,
  device,
  tab
}
